import * as React from "react";
import { alpha } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Routes, Route } from "react-router-dom";
import AppTheme from "../../src/shared-theme/AppTheme";
import { xThemeComponents } from "./theme/customizations";
import { useNavigate } from "react-router-dom";
import SideMenu from "./components/SideMenu";
import AppNavbar from "./components/AppNavbar";
// import Header from "./components/Header";
import MainGrid from "./components/MainGrid";
import FreightForm from "./components/Freight/FreightEntryForm";
import FreightList from "./components/Freight/FreightList";
// New Frieght File Imported Here
import FreightFilter from "./components/Freight/FreightFilter";
import IssueForm from "./components/Issue/IssueForm";
import IssueList from "./components/Issue/IssueList";
import AddNewUser from "./components/User/AddNewUser";
import UserList from "./components/User/UserList";
import AddBranch from "./components/Branch/AddNewBranch";
import BranchList from "./components/Branch/BranchList";
import AddParty from "./components/Party/AddParty";
import PartyList from "./components/Party/PartyList";
import FreightInvoice from "./components/Freight/FreightInvoice";
import TodayHistoryTable from "./components/History/TodayHistory";
import PastHistoryTable from "./components/History/PastHistory";
import Pendingforbill from "./components/Reports/Pendingforbill";
import Pendingforpayment from "./components/Reports/Pendingforpayment";
import Allfreight from "./components/Reports/Allfreight";
import Partyfreight from "./components/Reports/Partyfreight";
import Vehiclefreight from "./components/Reports/Vehiclefreight";
import Completefreight from "./components/Reports/Completefreight";
import Branchfreight from "./components/Reports/Branchfreight";
// import BillList from "./components/Reports/BillList";
import PaymentPanding from "./components/Reports/PaymentPanding";
import PartyBill from "./components/Reports/PartyBill";
import BranchBill from "./components/Reports/Branchbill";
import PaymentList from "./components/Reports/PaymentList";
import PartyPayment from "./components/Reports/PartyPayment";
import BranchPayment from "./components/Reports/BranchPayment";
import BillCreationForm from "./components/Bill/BillCreation";
import BillList from "./components/Bill/BillList";
import FreightPaymentTable from "./components/Freight/FreightPayment";
import PaymentTable from "./components/Payment";
import Allbills from "./components/Reports/Allbills";
import Billpendingfreight from "./components/Reports/Billpendingfreight";
import Completebill from "./components/Reports/Completebill";
import BranchBills from "./components/Reports/Branchbill";
import PartyRestore from "./components/Restore/party";
import BranchRestore from "./components/Restore/branch";
import FreightRestore from "./components/Restore/freight";
import StaffRestore from "./components/Restore/staff";
import FreightPaymentReport from "./components/Reports/FreightPaymentReport";
import BillRestore from "./components/Restore/BillRestore";
export default function Dashboard(props) {
  const [freightData, setFreightData] = React.useState([]);
  const [selectedEntry, setSelectedEntry] = React.useState(null);
  const [isEditMode, setIsEditMode] = React.useState(false);
  const navigate = useNavigate(); // at top

  // When edit icon is clicked
  const handleEdit = (entry, index) => {
    setSelectedEntry({ ...entry, index }); // Add index for tracking which row to update
    setIsEditMode(true);
  }; 

  // When form is submitted
  const handleSave = (formData) => {
    if (isEditMode && formData.index !== undefined) {
      const updatedData = [...freightData];
      const { index, ...cleanedData } = formData;
      updatedData[index] = { ...cleanedData, index };
      setFreightData(updatedData);
      setIsEditMode(false);
      setSelectedEntry(null);
    } else {
      setFreightData([...freightData, formData]);
    }

    navigate("/dashboard/freight-list");
  };


  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: "flex" }}>
        <SideMenu />
        <AppNavbar />

        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: "auto",
          })}
        >

          <Stack
            spacing={2}
            sx={{
              alignItems: "center",
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            {/* <Header /> */}
          </Stack>


          <Box sx={{ px: 3, pb: 3 }}>
            <Routes>
              <Route path="/" element={<MainGrid />} />
              <Route
                path="/freight-form"
                element={
                  <FreightForm
                    initialData={selectedEntry}
                    isEdit={isEditMode}
                    onSave={handleSave}
                  />
                }
              />
              <Route
                path="/freight-list"
                element={<FreightList data={freightData} onEdit={handleEdit} />}
              />
              <Route path="/issue-form" element={<IssueForm />} />
              <Route path="/issue-list" element={<IssueList />} />
              <Route path="/addnewstaff" element={<AddNewUser />} />
              <Route path="/stafflist" element={<UserList />} />
              <Route path="/addbranch" element={<AddBranch />} />
              <Route path="/branchlist" element={<BranchList />} />
              <Route path="/addparty" element={<AddParty />} />
              <Route path="/partylist" element={<PartyList />} />
             
              <Route path="/freightinvoice" element={<FreightInvoice />} />
            
              <Route path="/todayhistory" element={<TodayHistoryTable />} />
              <Route path="/pasthistory" element={<PastHistoryTable />} />
              <Route path="/pendingforbill" element={<Pendingforbill />} />
              <Route
                path="/Pendingforpayment"
                element={<Pendingforpayment />}        
              />
              <Route path="/Allfreight" element={<Allfreight />} />
              <Route path="/Partyfreight" element={<Partyfreight />} />
              <Route path="/Vehiclefreight" element={<Vehiclefreight />} />
              <Route path="/Completefreight" element={<Completefreight />} />
              <Route path="/Branchfreight" element={<Branchfreight />} />
              <Route path="/billlist" element={<BillList />} />
              <Route path="/paymentpanding" element={<PaymentPanding />} />
              <Route path="/partybill" element={<PartyBill />} />
              <Route path="/branchbill" element={<BranchBill />} />
              <Route path="/paymentlist" element={<PaymentList />} />
              <Route path="/partyPayment" element={<PartyPayment />} />
              <Route path="/branchpayment" element={<BranchPayment />} />
              <Route path="/bill-creation" element={<BillCreationForm />} />
              <Route path="/bill-list" element={<BillList />} />
              <Route path="/freightpayment" element={<FreightPaymentTable />} />
              <Route path="/payment" element={<PaymentTable />} />
              <Route path="/Allbills" element={<Allbills />} />   
              <Route
                path="/Billpendingfreight"
                element={<Billpendingfreight />}
              />

              <Route path="/Completebill" element={<Completebill />} />

              <Route path="/BranchBills" element={<BranchBills />} />
            
              <Route path="/freight/payment/report" element={<FreightPaymentReport />} />

              {/* Add more routes as needed */}
              <Route path="/restore/branch" element={<BranchRestore />} />
              <Route path="/restore/party" element={<PartyRestore />} />
              <Route path="/restore/staff" element={<StaffRestore />} />
              <Route path="/restore/freight" element={<FreightRestore />} />
              <Route path="/restore/bill" element={<BillRestore />} />

              <Route path="/freightfilter" element={<FreightFilter/>} />
              
            </Routes>
          </Box>
        </Box>
      </Box>
    </AppTheme>
  );
}











